export default __webpack_public_path__ + "static/media/brand-text.de81a7b7.png";